import { FocusMonitor } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import {
  FloatLabelType,
  MatFormField,
  MatFormFieldAppearance,
} from '@angular/material/form-field';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps as CoreFormlyFieldProps,
  ɵdefineHiddenProp as defineHiddenProp,
} from '@ngx-formly/core';
import { FormlyWrapperFormField } from '@ngx-formly/material/form-field/form-field.wrapper';

interface MatFormlyFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  _formField?: FormlyWrapperFormField;
}

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  className?: string;
  heading?: string;
  prefix?: TemplateRef<any>;
  suffix?: TemplateRef<any>;
  textPrefix?: TemplateRef<any>;
  textSuffix?: TemplateRef<any>;
  hideLabel?: boolean;
  hideRequiredMarker?: boolean;
  hideFieldUnderline?: boolean;
  hideIndicator?: boolean;
  floatLabel?: FloatLabelType;
  appearance?: MatFormFieldAppearance;
  subscriptSizing?: 'fixed' | 'dynamic';
  color?: ThemePalette;
  hintStart?: TemplateRef<any> | string;
  hintEnd?: TemplateRef<any> | string;
  readonly?: boolean;
  useExternalLabel?: boolean;
}

@Component({
  selector: 'lockton-apps-form-field-wrapper',
  templateUrl: './mat-form-field-wrapper.component.html',
  styleUrls: ['./mat-form-field-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MatFormFieldWrapperComponent
  extends FieldWrapper<MatFormlyFieldConfig>
  implements OnInit, AfterViewInit, OnDestroy
{
  @HostBinding('class') hostClass = 'w-100';
  @ViewChild(MatFormField, { static: true }) formField!: MatFormField;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private focusMonitor: FocusMonitor
  ) {
    super();
  }

  ngOnInit() {
    defineHiddenProp(this.field, '_formField', this.formField);
    this.focusMonitor.monitor(this.elementRef, true).subscribe((origin) => {
      if (!origin && this.field.focus) {
        this.field.focus = false;
      }
    });
  }

  ngAfterViewInit() {
    if (
      this.formField.appearance !== 'outline' &&
      this.props.hideFieldUnderline === true
    ) {
      const underlineElement =
        this.formField._elementRef.nativeElement.querySelector(
          '.mat-form-field-underline'
        );
      underlineElement &&
        this.renderer.removeChild(
          underlineElement.parentNode,
          underlineElement
        );
    }
  }

  ngOnDestroy() {
    delete this.field._formField;
    this.focusMonitor.stopMonitoring(this.elementRef);
  }
}
